export default [
  // {
  //   path: '/admin/document-types',
  //   name: 'indexDocumentTypesAdmin',
  //   meta: { title: 'indexDocumentTypesAdmin' },
  //   component: () => import('@/pages/admin/document-types'),
  // },
  // {
  //   path: "/admin/document-types/create",
  //   name: "createDocumentTypesAdmin",
  //   meta: { title: 'createDocumentTypesAdmin' },
  //   component: () => import('@/pages/admin/document-types/create'),
  // },
  // {
  //   path: "/admin/document-types/:id/edit",
  //   name: "editDocumentTypesAdmin",
  //   meta: { title: 'editDocumentTypesAdmin' },
  //   component: () => import('@/pages/admin/document-types/edit'),
  // },
]
